// extracted by mini-css-extract-plugin
export default {"container":"ProcesRowDetails_container__WLArF","stage":"ProcesRowDetails_stage__O7WVu","btn_zamknij":"ProcesRowDetails_btn_zamknij__7Lalo"};